import { AppState } from '@smdapp/flux';

export const INITIAL_STATE: AppState = {
    documentoTramite:{},
    tipoAutenticacao: null
};
